import { render, staticRenderFns } from "./DropdownCustomPositionTop.vue?vue&type=template&id=b336a62c&scoped=true&"
import script from "./DropdownCustomPositionTop.vue?vue&type=script&lang=js&"
export * from "./DropdownCustomPositionTop.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCustomPositionTop.vue?vue&type=style&index=0&id=b336a62c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b336a62c",
  null
  
)

export default component.exports